import Dialog, {
  DialogTitle,
  DialogContent,
  DialogFooter,
  DialogButton,
} from '@material/react-dialog';
import './Dialog.scss';

/**
 * Dialog MCWR Component
 *
 * @version ./package.json
 */
export default Dialog;

export {
  DialogTitle,
  DialogContent,
  DialogFooter,
  DialogButton,
};
